<template>
    <form @submit.prevent>
        <div>
            <div class="a-table a-table--really-wide">
                <table class="a-table--full-width" cellpadding="0" cellspacing="0">
                    <thead>
                        <tr>
                            <th>Period</th>
                            <th>Employment Income</th>
                            <th>Net/Gross</th>
                            <th>Total Net Income</th>
                            <th>
                                <div class="p-pi-income__ashe-average">
                                    <p>ASHE Average</p>
                                    <modal-in-the-wild modal-name="ashe">
                                        <div class="p-pi-income__ashe-average-tooltip">
                                            <icon-tooltip
                                                tooltip-text="Click to view information"
                                                side="bottom"
                                                text-width="140"
                                                icon-type="info"
                                                icon-colour="m-icon--light">
                                            </icon-tooltip>
                                        </div>
                                    </modal-in-the-wild>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Pre-Accident Earnings
                            </td>
                            <td>
                                <div class="a-form-inputs--pound">
                                    <input autocomplete="off"
                                           type="number" min="0"
                                           v-two-dp
                                           required
                                           v-model="preEmploymentIncome"
                                           :disabled="getIncomeValue('pastLossOfEarnings')">
                                </div>
                            </td>
                            <td>
                                <control
                                        tip-text="ASHE Data are gross median figures. Therefore the Net function has been disabled. To re-enable edit the employment income figure."
                                        tip-icon="info"
                                        tip-side="left"
                                        tip-width="250"
                                        tip-name="future_losses_constant"
                                        :tipShow="!getIncomeValue('pastLossOfEarnings') && preAccidentDisableNetGross"
                                        :table-control="true">
                                    <select v-model="preEmploymentNetGross"
                                            :disabled="getIncomeValue('pastLossOfEarnings') || preAccidentDisableNetGross">
                                        <option value="net">Net</option>
                                        <option value="gross">Gross</option>
                                    </select>
                                </control>
                            </td>
                            <td>
                                <div class="a-form-inputs--pound">
                                    <input autocomplete="off"
                                           type="number"
                                           v-two-dp
                                           disabled
                                           v-model="preTotalNetIncome">
                                </div>
                            </td>
                            <td>
                                <button class="a-button u-no-margin ashe p-pi-income__ashe-average-button"
                                        @click="selectSalary(null, 'pre')"
                                        :disabled="getIncomeValue('pastLossOfEarnings')">
                                    Use ASHE average
                                </button>
                                <button class="a-button u-no-margin refine"
                                        @click="openDialog('pre')"
                                        :disabled="getIncomeValue('pastLossOfEarnings')">
                                    Refine by occupation
                                </button>
                            </td>
                        </tr>
                        <tr v-if="getIncomeValue('pastLossOfEarnings') || futureLossesConstant">
                            <td>
                                Post-Accident Earnings
                            </td>
                            <td>
                                <div class="a-form-inputs--pound">
                                    <input autocomplete="off" type="number" min="0" v-two-dp required
                                           v-model.number="postEmploymentIncome"
                                           v-on:focus="postEmploymentIncome = postEmploymentIncome || ''"
                                           v-on:blur="postEmploymentIncome = postEmploymentIncome || 0">
                                </div>
                            </td>
                            <td>
                                <control
                                        tip-text="ASHE Data are gross median figures. Therefore the Net function has been disabled. To re-enable edit the employment income figure."
                                        tip-icon="info"
                                        tip-side="left"
                                        tip-width="250"
                                        tip-name="future_losses_constant"
                                        :tipShow="postAccidentDisableNetGross"
                                        :table-control="true">
                                    <select v-model="postEmploymentNetGross" :disabled="postAccidentDisableNetGross">
                                        <option value="net">Net</option>
                                        <option value="gross">Gross</option>
                                    </select>
                                </control>
                            </td>
                            <td>
                                <div class="a-form-inputs--pound">
                                    <input autocomplete="off" type="number" v-two-dp disabled v-model="postTotalNetIncome">
                                </div>
                            </td>
                            <td>
                                <button class="a-button u-no-margin ashe p-pi-income__ashe-average-button" @click="selectSalary(null, 'post')">
                                    Use ASHE average
                                </button>
                                <button class="a-button u-no-margin refine" @click="openDialog('post')">
                                    Refine by occupation
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <modal :name="'ons_salary_'+this.uniqueId" no-default-button="true">
            <div class="p-day-one__refine-occupation">
                <h2>Refine by occupation</h2>

                <div v-if="selectedNode">
                    <p>
                        Your current selection - <strong>{{ getLastNode().description }}</strong><br/>
                        <span v-if="getLastNode().code.length !== 3">Select a salary, expand down further or use the average salary for this whole group</span>
                        <span v-else>Select a salary or use the average salary for this whole group</span>
                    </p>

                    <button @click="unselectNode(selectedNode)" class="a-button a-button--small">Back</button>
                    <button @click="selectSalary(selectedNode)" class="a-button a-button--small">Use average {{displaySalary(selectedNode)}}</button>
                </div>
                <div v-else>
                    <p>
                        Select a salary or expand the group
                    </p>
                </div>
                <div>
                    <div>
                        <table class=" a-table__small a-table a-table--full-width">
                            <thead>
                            <tr>
                                <th>Code</th>
                                <th>Description</th>
                                <th>Salary</th>
                                <th width="30"></th>
                                <th width="30"></th>
                            </tr>
                            </thead>
                            <tbody v-if="loading">
                            <td colspan="5" style="text-align: center;"><div class="a-loader--table"></div></td>
                            </tbody>
                            <tbody v-else>
                            <tr v-for="node in nodes" class="selected--row">
                                <td>{{node.code}}</td>
                                <td>{{node.description}}</td>
                                <td>{{displaySalary(node)}}</td>
                                <td>
                                    <button :disabled="node.code.length === 4" class="a-button a-button--small" @click.stop="selectNode(node)">
                                        Expand
                                    </button>
                                </td>
                                <td>
                                    <button v-if="node.salary!=='x'" class="a-button a-button--small" @click.stop="selectSalary(node, type)">
                                        Select
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </modal>
        <modal name="ashe" no-default-button="true">
            <h2>ASHE Average</h2>
            We have provided average gross (median) earnings by selected gender &amp; occupational categories according to the Average Survey of Hours and Earnings (ASHE). The data are collected and published by the Office of National Statics (ONS) annually and can be found here.
        </modal>
    </form>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import FormValidator from 'components/form/validator/mixin';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import Api from 'services/Api';
    import CurrencyFormat from 'mixins/currencyFormat';
    import IconTooltip from 'components/IconTooltip';
    import Modal from 'components/modal/Modal';
    import ModalContent from 'components/modal/ModalContent';
    import ModalInTheWild from 'components/modal/ModalInTheWild';

    export default {
        name: 'post-accident-income',
        data() {
            return {
                loading: false,
                nodes: [],
                selectedNode: null,
                selectedNodes: [],
                preAccidentDisableNetGross: false,
                postAccidentDisableNetGross: false
            }
        },
        mounted() {
            this.checkForPreAccidentEarnings()
        },
        components: {
            Control,
            ControlError,
            IconTooltip,
            Modal,
            ModalContent,
            ModalInTheWild
        },
        mixins: [
            CurrencyFormat,
            FormValidator
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('personal/claimant', ['claimant', 'getIncomeValue']),
            ...mapGetters('personal/futureLosses', ['getLoss',]),
            ...mapGetters('modal', ['modals']),
            isModalOpen() {
                let ons_salary = 'ons_salary_'+this.uniqueId;
                return this.modals && this.modals[ons_salary];
            },
            uniqueId() {
                return this._uid;
            },
            futureLossesConstant: {
                get() {
                    return this.getLoss('futureLossesConstant');
                },
            },
            preEmploymentIncome: {
                get() {
                    return this.getIncomeValue('futureEarningsPreAccident').employmentIncome;
                },
                set(value) {
                    this.preAccidentDisableNetGross = false;
                    this.updateFutureEarningsPreAccidentEarningsValue({key: 'employmentIncome', value}).then(
                        this.updateFutureEarningsPreAccidentEarnings
                )}
            },
            preEmploymentNetGross: {
                get() {
                    return this.getIncomeValue('futureEarningsPreAccident').employmentNetGross;
                },
                set(value) {
                    this.updateFutureEarningsPreAccidentEarningsValue({key: 'employmentNetGross', value}).then(
                        this.updateFutureEarningsPreAccidentEarnings
                )}
            },
            preTotalNetIncome: {
                get() {
                    return this.getIncomeValue('futureEarningsPreAccident').totalNetIncome;
                },
            },
            postEmploymentIncome: {
                get() {
                    return this.getIncomeValue('futureEarningsPostAccident').employmentIncome;
                },
                set(value) {
                    this.postAccidentDisableNetGross = false;
                    this.updateFutureEarningsPostAccidentEarningsValue({key: 'employmentIncome', value}).then(
                        this.updateFutureEarningsPostAccidentEarnings
                )}
            },
            postEmploymentNetGross: {
                get() {
                    return this.getIncomeValue('futureEarningsPostAccident').employmentNetGross;
                },
                set(value) {
                    this.updateFutureEarningsPostAccidentEarningsValue({key: 'employmentNetGross', value}).then(
                        this.updateFutureEarningsPostAccidentEarnings
                )}
            },
            postTotalNetIncome: {
                get() {
                    return this.getIncomeValue('futureEarningsPostAccident').totalNetIncome;
                },
            },
        },
        methods: {
            ...mapActions('personal/claimant', [
                'updateFutureEarningsPreAccidentEarnings',
                'updateFutureEarningsPreAccidentEarningsValue',
                'updateFutureEarningsPostAccidentEarnings',
                'updateFutureEarningsPostAccidentEarningsValue',
            ]),
            ...mapActions('modal', ['toggle']),
            openDialog(type) {
                if (!this.isModalOpen) {
                    this.nodes = [];
                    this.selectedNode = null;
                    this.selectedNodes = [];
                    this.type = type;
                    return this.toggle('ons_salary_'+this.uniqueId).then(this.updateNodes);
                }
            },
            closeModal() {
                if (this.isModalOpen) {
                    this.type = null;
                    return this.toggle('ons_salary_'+this.uniqueId);
                }
            },
            updateNodes(code = null) {
                this.loading = true;
                Api.calculators.ons.salary(this.gender, code)
                    .then(nodes => {
                        this.nodes = nodes;
                        this.loading = false;
                    });
            },
            selectNode(node) {
                if (node.code.length === 4) {
                    return;
                }
                this.selectedNode = node;
                this.selectedNodes.push(node);
                return this.updateNodes(node.code);
            },
            unselectNode(node) {
                let index = this.selectedNodes.indexOf(node);
                if (index === 0) {
                    this.selectedNodes = [];
                    this.selectedNode = null;
                    return this.updateNodes();
                }
                this.selectedNodes.splice(index);
                let lastIndex = this.selectedNodes.length - 1;
                this.selectedNode = this.selectedNodes[lastIndex];
                this.updateNodes(this.selectedNode.code);
            },
            selectSalary(node, type) {
                if (node === null) {
                    return Api.calculators.ons.averageSalary(this.claimant.gender)
                        .then(result => {
                            if (type === 'pre') {
                                this.preEmploymentIncome = result.value;
                                this.updateFutureEarningsPreAccidentEarningsValue({key: 'employmentNetGross', value: 'gross'});
                                this.preAccidentDisableNetGross = true;
                                this.updateFutureEarningsPreAccidentEarningsValue({key: 'employmentIncome', value: result.value }).then(
                                    this.updateFutureEarningsPreAccidentEarnings
                                )
                            } else {
                                this.postEmploymentIncome = result.salary ;
                                this.updateFutureEarningsPostAccidentEarningsValue({key: 'employmentNetGross', value: 'gross' });
                                this.postAccidentDisableNetGross = true;
                                this.updateFutureEarningsPostAccidentEarningsValue({key: 'employmentIncome', value: result.value }).then(
                                    this.updateFutureEarningsPostAccidentEarnings
                                )
                            }
                        }).then(this.closeModal);
                }
                this.employmentIncome = node.salary ;

                if (type === 'pre') {
                    this.preEmploymentIncome = node.salary;
                    this.updateFutureEarningsPreAccidentEarningsValue({key: 'employmentIncome', value: node.salary }).then(
                        this.updateFutureEarningsPreAccidentEarnings
                    )
                } else {
                    this.postEmploymentIncome = node.salary ;
                    this.updateFutureEarningsPostAccidentEarningsValue({key: 'employmentIncome', value: node.salary }).then(
                        this.updateFutureEarningsPostAccidentEarnings
                    )
                }
                this.closeModal();
            },
            displaySalary(node) {
                if (node.salary === "x") {
                    return "No Information";
                }
                return this.currencyFormat(node.salary, '£', 0);
            },
            getLastNode() {
                return this.selectedNodes.slice(-1)[0];
            },
            checkForPreAccidentEarnings() {
                if (this.getIncomeValue('pastLossOfEarnings')) {
                    this.updateFutureEarningsPreAccidentEarningsValue({
                        key: 'employmentIncome',
                        value: this.getIncomeValue('preAccident').employmentIncome});

                    this.updateFutureEarningsPreAccidentEarningsValue({
                        key: 'employmentNetGross',
                        value: this.getIncomeValue('preAccident').employmentNetGross});

                    this.updateFutureEarningsPreAccidentEarnings();
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// PostAccidentIncome.vue?bb4dfee8